module.exports = __webpack_public_path__ + "img/icon_project03.802db36e.png";